import { render, staticRenderFns } from "./fitting.vue?vue&type=template&id=0b8d0c42&scoped=true&"
import script from "./fitting.vue?vue&type=script&lang=js&"
export * from "./fitting.vue?vue&type=script&lang=js&"
import style0 from "./fitting.vue?vue&type=style&index=0&id=0b8d0c42&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8d0c42",
  null
  
)

export default component.exports